import { render, staticRenderFns } from "./AddSale.vue?vue&type=template&id=006c5438&scoped=true"
import script from "./AddSale.js?vue&type=script&lang=js&external"
export * from "./AddSale.js?vue&type=script&lang=js&external"
import style0 from "./AddSale.scss?vue&type=style&index=0&id=006c5438&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006c5438",
  null
  
)

export default component.exports